/**
 * Get the appropriate color for platform badges based on the platform's theme color
 */
export function getPlatformColor(platform?: { themeColor?: string | null; slug?: string } | null): string {
    // If platform has themeColor, use it
    if (platform?.themeColor) {
        const colorMap: Record<string, string> = {
            'nintendo': 'nintendo',
            'xbox': 'xbox',
            'playstation': 'playstation',
            'pc': 'pc',
        };
        return colorMap[platform.themeColor] || 'blue';
    }

    // Fallback: try to determine color from slug
    if (platform?.slug) {
        const slugColorMap: Record<string, string> = {
            'switch': 'nintendo',
            'switch-2': 'nintendo',
            'ps4': 'playstation',
            'ps5': 'playstation',
            'xbox-one': 'xbox',
            'xbox-series': 'xbox',
            'pc': 'pc',
        };
        return slugColorMap[platform.slug] || 'blue';
    }

    return 'blue'; // Default fallback color
} 